import { use } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link as LinkIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CopyButton from 'shared/components/buttons/copy-button/copy-button';
import PopUp from 'shared/components/pop-up/pop-up';
import AuthProviderContext from 'shared/features/auth/authentication/providers/contexts/auth-provider-context';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import useGatewaySettingsViewpointClient from 'features/gateway/hooks/gateway-settings-viewpoint-client-hook';
import styles from 'features/gateway/views/gateway-details/gateway-settings/gateway-settings-clients/gateway-settings-client.module.scss';

const GatewaySettingsViewpointClient = () => {
  const { t } = useTranslation('gateway');

  const {
    tenant: { name: tenantName },
  } = use(AuthProviderContext);

  const { gatewayDetailsHook } = useGatewaysContextProvider();

  const {
    clientId,
    clientSecret,
    generateSecretIsLoading,
    isGenerateSecretConfirmationOpen,
    defaultSecret,
    generateSecret,
    submitGenerateSecret,
    closeGenerateSecretConfirmationPopup,
  } = useGatewaySettingsViewpointClient();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoItem}>
          <Typography variant="subtitle1">{t('details.settings.tenantLabel')}:</Typography>
          <Typography variant="subtitle1">{t('details.settings.clientIdLabel')}:</Typography>
          <Typography variant="subtitle1">{t('details.settings.clientSecretLabel')}:</Typography>
        </div>
        <div className={styles.infoItem}>
          <Typography variant="subtitle1">{tenantName}</Typography>
          <div className={styles.secret}>
            <Typography variant="subtitle1" data-testid="gatewayClientId">
              {clientId && clientId.length > 0 ? clientId : '-'}
            </Typography>
            {clientId && <CopyButton contentToCopy={clientId} />}
          </div>
          <div className={styles.secret}>
            <Typography variant="subtitle1">{clientSecret}</Typography>
            {clientSecret !== defaultSecret && <CopyButton contentToCopy={clientSecret} />}
          </div>
        </div>
      </div>
      {gatewayDetailsHook.viewingMode === 'viewing' &&
        (clientSecret === defaultSecret ? (
          <Button
            variant="outlined"
            onClick={generateSecret}
            startIcon={<LinkIcon />}
            loading={generateSecretIsLoading}
            loadingPosition="start"
            className={styles.secretButton}
            data-testid="generate-secret-button"
          >
            {t('details.settings.clientSecret.generateButton')}
          </Button>
        ) : (
          <Typography variant="subtitle1">{t('details.settings.clientSecret.warningViewpoint')}</Typography>
        ))}
      <PopUp
        isOpen={isGenerateSecretConfirmationOpen}
        title={t('details.settings.clientSecret.confirmation.title')}
        body={<Trans t={t} i18nKey="details.settings.clientSecret.confirmation.bodyText" />}
        primaryButtonText={t('details.settings.clientSecret.confirmation.confirmButton')}
        secondaryButtonText={t('details.settings.clientSecret.confirmation.cancelButton')}
        handleOnClose={closeGenerateSecretConfirmationPopup}
        secondaryButtonAction={closeGenerateSecretConfirmationPopup}
        primaryButtonAction={submitGenerateSecret}
      />
    </>
  );
};

export default GatewaySettingsViewpointClient;
